import React from 'react';
import { ReloadOutlined } from '@ant-design/icons';

import { DateTime } from 'luxon';

import OnTraccrButton from '../../../../common/buttons/OnTraccrButton';
import TableFilterDropdown from '../../../../common/tables/TableFilterDropdown';
import OntraccrTag from '../../../../common/OntraccrTag';

export default {};

const timeRender = (ts) => (
  ts
    ? DateTime.fromMillis(ts).toLocaleString(DateTime.DATETIME_MED_WITH_SECONDS)
    : null
);

const ACTIONS = [
  'Create PO',
  'Create Payment',
  'Create Bill',
  'Update Bill',
  'Create Expense',
  'Update Expense',
  'Create Invoice',
  'Create Time Entry',
  'Create Ontraccr Invoice',
];

const STATUSES = [
  'Failed',
  'Partial Success',
  'Succeeded',
];

const colorMap = {
  Failed: 'red',
  'Partial Success': 'orange',
  Succeeded: 'green',
};
const textColorMap = {
  Failed: 'red',
  'Partial Success': 'orange',
  Succeeded: 'green',
};

export const getLogColumns = (onRetry, retryingIds = new Set()) => [{
  title: 'Action',
  dataIndex: 'action',
  width: 100,
  filters: ACTIONS.map((name) => ({
    text: name,
    value: name,
  })),
  onFilter: (action, record) => record.action === action,
  filterDropdown: TableFilterDropdown,
}, {
  title: 'User',
  dataIndex: 'user',
  width: 100,
}, {
  title: 'Description',
  dataIndex: 'description',
  width: 300,
}, {
  title: 'Integration',
  dataIndex: 'integration',
  width: 100,
}, {
  title: 'Sent At',
  dataIndex: 'startTime',
  width: 100,
  sorter: (a, b) => a.startTime - b.startTime,
  showSorterTooltip: false,
  sortDirections: ['descend', 'ascend'],
  render: timeRender,
}, {
  title: 'Response At',
  dataIndex: 'endTime',
  width: 100,
  sorter: (a, b) => a.startTime - b.startTime,
  showSorterTooltip: false,
  sortDirections: ['descend', 'ascend'],
  render: timeRender,
}, {
  title: 'Status',
  dataIndex: 'status',
  width: 100,
  textAlign: 'center',
  filters: STATUSES.map((name) => ({
    text: name,
    value: name,
  })),
  onFilter: (status, record) => record.status === status,
  filterDropdown: TableFilterDropdown,
  render: (status) => (
    <OntraccrTag
      color={colorMap[status]}
      textStyle={{
        color: textColorMap[status],
      }}
      style={{
        border: `1px solid ${textColorMap[status]}`,
      }}
    >
      {status ?? 'Failed'}
    </OntraccrTag>
  ),
}, {
  title: 'Retried At',
  dataIndex: 'retriedAt',
  width: 150,
  sorter: (a, b) => a.retriedAt - b.retriedAt,
  showSorterTooltip: false,
  sortDirections: ['descend', 'ascend'],
  render: timeRender,
}, {
  title: 'Retried By',
  dataIndex: 'retriedByName',
  width: 100,
}, {
  title: '',
  key: 'actions',
  width: 80,
  render: (_, record) => {
    if (!onRetry || record.action !== 'Create Time Entry' || record.status !== 'Failed') {
      return null;
    }
    return (
      <OnTraccrButton
        title="Retry"
        icon={<ReloadOutlined />}
        loading={retryingIds.has(record.id)}
        onClick={(e) => {
          e.stopPropagation();
          onRetry(record);
        }}
      />
    );
  },
}];

export const logColumns = getLogColumns();
